import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Loader",
  name: "connectionStatus"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.isNoConnection ? _ctx.$t('Loader.awaitingPartner') : _ctx.$t('Loader.loading')), 1 /* TEXT */))
}